import { render } from "./SignUpLayout.vue?vue&type=template&id=5072623e&scoped=true"
import script from "./SignUpLayout.vue?vue&type=script&lang=js"
export * from "./SignUpLayout.vue?vue&type=script&lang=js"

import "./SignUpLayout.vue?vue&type=style&index=0&id=5072623e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5072623e"]])

export default __exports__